import React, { useEffect, useState } from "react";
// import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle, Button } from "reactstrap"
// import "./datatables.scss";
import '../Icons/IconFontawesome';

import Utils from '../Utility';
import { post, get, put } from "../../helpers/api_helper";
import DeleteModal from './DeleteModal';
import DataTable from 'react-data-table-component';
import './Card.scss';

const Projects = (props) => {
  const { user, role, currentUser, from } = props;
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);

  useEffect(() => {
    if (user) {
      getOpportunities();
    }
  }, [user]);

  const getOpportunities = () => {
    get("/oppor/list", { token: user?.token })
      .then(json => {
        // console.log('response from get project list', json);
        if (json?.statusCode == 200) {
          setData(json?.data);
        }
      })
      .catch(error => {
        console.log('error while getting project list', error);
      })
  }

  useEffect(() => {
    setColumns([
      {
        name: 'Title',
        cell: (row) => <>
          <span title={row.title}>{row.title}</span>
        </>
      },
      // {
      //   name: 'Description',
      //   cell: (row) => <>
      //     <span title={row?.desc}>{row.desc.length>45 ? row.desc.slice(0, 45)+"..." : row.desc}</span>
      //   </>,
      // },
      {
        name: 'Duration',
        selector: row => row.duration,
      },
      {
        name: 'Company',
        selector: row => row?.company[0]?.title,
      },
      {
        name: 'Course',
        selector: row => row?.course[0]?.title,
      },
      {
        name: 'Total Applicants',
        selector: row => 0,
      },
      {
        name: 'Posted On',
        selector: row => row.createdAt,
      },
      {
        cell: (row) => <>
          <Button onClick={() => handleUpdateStatus(row, 'course')}
            title={row?.isActive ? "Inactive" : "Active"}
            style={{ backgroundColor: !row.isActive ? 'red' : 'green', marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}>
            <span className="text-white" style={{}}>
              {!row?.isActive ? `Inactive ${row?.isActiveType ? ` for ${row?.isActiveType}` : ''}` : 'Active'}
            </span>
          </Button>
        </>,
        name: 'Status',
        ignoreRowClick: true,
      },
      {
        cell: (row) => <>
          <Button onClick={() => props?.history.push(`/opportunities/` + row?._id)}
            title={"Leads"}
            style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-eye" style={{ fontSize: 20 }}></span></Button>
          {from != 'Dashboard' &&
            <>
              <Button onClick={() => handleUpdateProj(row)}
                title={"Edit"}
                style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-pencil" style={{ fontSize: 20 }}></span></Button>
              <Button onClick={() => handleDeleteProj(row)}
                title={"Delete"}
                style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-delete" style={{ fontSize: 20 }}></span></Button>
            </>
          }
        </>,
        name: 'Action',
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
    ])
  }, [data]);

  const handleUpdateProj = (proj) => {
    proj.durationType = proj.duration.split(" ")[1];
    proj.duration = proj.duration.split(" ")[0];
    console.log('updating proj', proj.duration, proj.durationType);
    props?.setCurrentUser(proj);
    props.add(true);
  }

  const handleDeleteProj = (proj) => {
    console.log('updating proj', proj);
    props?.setCurrentUser({ ...proj, actionType: 'Delete' });
    setDeleteModal(true);
  }

  const handleUpdateStatus = (item) => {
    console.log('updating proj', item);
    props?.setCurrentUser({ ...item, actionType: 'Status' });
    setDeleteModal(true);
  }

  const onStatus = (type) => {
    console.log('deleted', currentUser, type);
    let body = {
      opporId: currentUser?._id,
      isActive: !currentUser?.isActive,
      isActiveType: type,
      token: user?.token
    }
    put("/oppor/update", body)
      .then(json => {
        console.log('response from delete user', json);
        if (json.statusCode == 200) {
          getOpportunities();
          setDeleteModal(false);
          props?.setCurrentUser(null);
        }
      })
      .catch(error => {
        console.error('error while deleting user', error);
      })
  }

  const onDelete = () => {
    console.log('deleted', currentUser);
    post("/oppor/delete", { opporId: currentUser?._id, token: user?.token })
      .then(json => {
        console.log('response from delete user', json);
        if (json.statusCode == 200) {
          getOpportunities();
          setDeleteModal(false);
          props?.setCurrentUser(null);
        }
      })
      .catch(error => {
        console.error('error while deleting user', error);
      })
  }

  return (
    <React.Fragment>
      <div className="">
        <Row>
          <DeleteModal
            show={deleteModal}
            onDeleteClick={(type) => currentUser?.actionType == 'Status' ? onStatus(type) : onDelete()}
            onCloseClick={() => setDeleteModal(false)}
            data={currentUser}
            actionType={currentUser?.actionType}
          />
          <Col className="col-12">
            <Card>
              <CardBody>
                {from != 'Dashboard' &&
                  <div className="d-flex" style={{ marginLeft: 'auto', marginBottom: 30 }}>
                    <div>
                      <CardTitle className="h4">{props.role}</CardTitle>
                      <CardSubtitle className="mb-3">
                        Opportunities you have added before, All the <code>Users</code> can be apply accordingly to an Opportunity.
                      </CardSubtitle>
                    </div>
                    <div className="text-center" style={{ marginLeft: 'auto' }}>
                      <Button style={{ backgroundColor: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor }} onClick={() => props?.add(true)}>
                        Add
                      </Button>
                    </div>
                  </div>
                }

                <DataTable
                  columns={columns}
                  data={data}
                  pagination
                  customStyles={{
                    headCells: {
                      style: {
                        color: 'black',
                        fontWeight: 'bold',
                        fontSize: 15,
                        maxWidth: 80
                      },
                    },
                    cells: {
                      style: {
                        maxWidth: 50
                      }
                    }
                  }}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

    </React.Fragment>
  )
}

export default Projects;
